<!--
  UIID: UI-Caas-MON-120
  UI Name: Status Information (popup)
  Modify Date: 2020/06/17
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display monitor-srch-layout-dialog"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text pl-0" primary-title>Input Search Key</v-card-title>
    </template>
    <template v-slot:button-close>
      <icon-svg iconName="close" />
    </template>
    <v-card class="v-dialog-1">
      <v-card-text class="pb-0 card-text-scroll">
        <v-row class="no-gutters mt-0 status-section-mb">
          <v-col cols="12" class="pr-0 pt-0 pb-0 text-right">
            Input multiple key value seperated by Enter key.
            <v-textarea
              v-model="dataValue"
              hide-details
              outlined
              dense
              class="input-search-key-custom pb-2"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-row class="ma-0">
        <v-col class="pa-0" lg="12">
          <div class="text-right">
            <v-btn class="btn btn-active mr-1" @click="selectOk($event)">OK</v-btn>
            <v-btn class="btn btn-delete" @click="removeDialog($event)">Close</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';

const moment = require('moment');

export default {
  // props: ['id', 'title', 'options', 'eventCb', 'closeDialog', 'dragStart', 'dragEnd','flatFile', 'errViewInfo', 'gmtTmzn'],
  props: {
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    searchKeyVal: String,
    //srchKeyVal:String,
    // dataValue: {
    //       default: Object,
    //   },
  },
  components: {
    DialogDrag,
    IconSvg,
  },
  name: 'input-searchkey-view-window',

  data() {
    return {
      dataValue: '',
    };
  },

  methods: {
    initialize() {
      this.dataValue = this.searchKeyVal;
    },

    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    selectOk(dialog) {
      this.$emit('select-ok', this.dataValue);
      this.removeDialog(dialog);
    },
  },

  created() {
    this.initialize();
  },
};
</script>

<style scoped>
.monitor-srch-layout-dialog {
  width: 500px;
}

.theme--dark .monitor-srch-layout-dialog .v-card__text {
  font-size: 13px;
  line-height: 19px;
  background-color: #3b3e49;
}

.theme--light .monitor-srch-layout-dialog .v-card__text {
  font-size: 13px;
  line-height: 19px;
}

.status-section-mb {
  margin-bottom: 10px;
}
</style>
